import React, { FC } from 'react';
import useCiaData from '@components/EntityDrawers/components/CiaInputsGroup/hooks/useCiaData';
import {
  Description,
  Wrapper,
} from '@components/EntityDrawers/components/IncludeInReportSwitch/IncludeInReportSwitch.styles';
import { CommonKeys } from '@components/EntityDrawers/constants/keys';
import ControlledSwitch from '@components/Inputs/controllers/ControlledSwitch';
import { useProject } from '@context/Project/ProjectProvider';
import { Stack, Typography } from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import { ReportIcon } from '@utils/iconsDefs';

const IncludeInReportSwitch: FC = () => {
  const { viewOnly } = useProject();
  const { isCiaActivated } = useCiaData();

  if (!isCiaActivated) return null;

  return (
    <Wrapper>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flex={1}
      >
        <Stack direction="row" alignItems="center" gap={2}>
          <ReportIcon width={20} height={19} fill={themePalette.grey[1000]} />
          <Typography variant="h5">Include in report</Typography>
        </Stack>

        <ControlledSwitch
          name={CommonKeys.IsReported}
          fullWidth={false}
          disabled={viewOnly}
        />
      </Stack>

      <Description>
        {'Determines whether this entity appears in the \nfinal report'}
      </Description>
    </Wrapper>
  );
};

export default IncludeInReportSwitch;
